export class ShipmentTypes {
    static readonly Empty = 'EMPTYCNT';
    static readonly Full = 'FULLCNT';
    static readonly Non = 'NONCNTC';
    static readonly Roro = 'RORO';

    static readonly ContainerShipmentTypes = [ShipmentTypes.Empty, ShipmentTypes.Full];
}

